import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { ViewType } from "../types";

interface CustomerDetailUIState {
  // View state
  viewType: ViewType;
  isEditDialogOpen: boolean;

  // Actions
  setViewType: (viewType: ViewType) => void;
  openEditDialog: () => void;
  closeEditDialog: () => void;
}

export const useCustomerDetailUIStore = create<CustomerDetailUIState>()(
  devtools(
    (set) => ({
      // Initial state
      viewType: "overview",
      isEditDialogOpen: false,

      // Actions
      setViewType: (viewType) => set({ viewType }),
      openEditDialog: () => set({ isEditDialogOpen: true }),
      closeEditDialog: () => set({ isEditDialogOpen: false }),
    }),
    { name: "customer-detail-ui-store" }
  )
);
